"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfig = void 0;
exports.envConfig = {
    env: process.env.NODE_ENV,
    infraStage: process.env.INFRA_STAGE,
    apiURL: process.env.REACT_APP_API,
    currentBrand: process.env.CURRENT_BRAND || process.env.REACT_APP_CURRENT_BRAND,
    customerBffUrl: process.env.REACT_APP_VD_CUSTOMER_BFF_URL,
    forgotPasswordUrl: process.env.REACT_APP_PRIVACY_POLICY,
    genericUrl: process.env.GENERIC_URL || process.env.REACT_APP_GENERIC_URL,
    genericUserName: process.env.GENERIC_USER_NAME || process.env.REACT_APP_GENERIC_USER_NAME,
    imageStandardLogo: process.env.REACT_APP_IMAGE_STANDARD_LOGO,
    platformText: process.env.PLATFORM_TEXT || process.env.REACT_APP_PLATFORM_TEXT,
    privacyPolicy: process.env.REACT_APP_PRIVACY_POLICY,
    termsOfUse: process.env.REACT_APP_TERMS_OF_USE,
    urlRedirect: process.env.URL_REDIRECT || process.env.REACT_APP_URL_REDIRECT,
    urlRedirectMultimarca: process.env.URL_REDIRECT_MULTIMARCA || process.env.REACT_APP_URL_REDIRECT_MULTIMARCA,
    urlText: process.env.URL_TEXT || process.env.REACT_APP_URL_TEXT,
    userText: process.env.USER_TEXT || process.env.REACT_APP_USER_TEXT,
    configCatKey: process.env.REACT_APP_CONFIGCAT_KEY || '',
    configCatCacheTTL: Number(process.env.REACT_APP_CONFIGCAT_CACHE_TTL || 60),
    checkoutApiUrl: process.env.CHECKOUT_API_URL || process.env.REACT_APP_CHECKOUT_API_URL,
    checkoutApiKey: process.env.CHECKOUT_API_KEY || process.env.REACT_APP_CHECKOUT_API_KEY,
    multibrandUrl: process.env.REACT_APP_MULTIBRAND_URL,
};
const emptyEnvs = Object.entries(exports.envConfig).filter(([_, env]) => env == null || !String(env).length);
if (!emptyEnvs.length) {
    // eslint-disable-next-line no-console
    console.warn(`[barril-del-chavo] Some env vars are empty: ${emptyEnvs.map(([name]) => name).join(', ')}`);
}
